import { render } from "./UserApplications.vue?vue&type=template&id=941194a6"
import script from "./UserApplications.vue?vue&type=script&lang=js"
export * from "./UserApplications.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src676743866/src/profileSite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__